const legacyProductionIds = {
  card: 'pk_a232d9113a150f54fb5bcaaece576',
  sbp: 'pk_73ab0e57a42668c245ece2a60e6f6',
};

// Public merchant identifiers are build settings, never API secrets. A TEST
// build must not fall back to either of the old production merchants.
export const getCloudPaymentsPublicId = method => {
  if (!Object.prototype.hasOwnProperty.call(legacyProductionIds, method))
    throw new Error('Оплата временно недоступна.');
  const configured = process.env.REACT_APP_CLOUDPAYMENTS_PUBLIC_ID;
  if (configured !== undefined && configured !== '') {
    if (!/^pk_[A-Za-z0-9]{1,124}$/.test(configured))
      throw new Error('Оплата временно недоступна.');
    return configured;
  }
  let production = false;
  try {
    production = process.env.REACT_APP_ENVIRONMENT === 'production' &&
      new URL(process.env.REACT_APP_API_URL).origin === 'https://you-wanna.ru';
  } catch { /* Missing or malformed TEST settings cannot select a live key. */ }
  if (!production) throw new Error('Оплата временно недоступна.');
  return legacyProductionIds[method];
};
